// extracted by mini-css-extract-plugin
export default {"container":"additional-data_container__938zT","custom-grid":"additional-data_custom-grid__Ag+mX","add-button":"additional-data_add-button__MqgdN"};